/** Menu items with `requiresThreatPairModule: true` are hidden unless org has threat pair enabled (admins/self). */
export const MENU = [
  {
    route: '/end-users',
    resourceName: 'End Users',
    label: 'End Users',
    icon: 'person-fill',
    children: {
      route: '/end-users/:id',
      resourceName: 'End Users Activities',
      label: 'Detail',
    },
  },
  {
    route: '/monitored-users',
    resourceName: 'Monitored Users',
    label: 'Monitored Users',
    icon: 'person-plus-fill',
    requiresThreatPairModule: true,
  },
  {
    route: '/devices',
    resourceName: 'Devices',
    label: 'Devices',
    icon: 'watch',
  },
  {
    route: '/organizations',
    resourceName: 'Organizations',
    label: 'Organizations',
    icon: 'diagram-3-fill',
  },
  /*{
    route: '/watch-themes',
    resourceName: 'Watch Themes',
    label: 'Watch Themes',
    icon: 'watch',
    requiresSuperAdmin: true,
  },*/
  {
    route: '/administrators',
    resourceName: 'Admins',
    label: 'Administrators',
    icon: 'person-fill',
  },
  {
    route: '/role-and-permissions',
    resourceName: 'Role and Permissions',
    label: 'Roles and Permissions',
    icon: 'shield-lock-fill',
  },
  {
    route: '/activity-logs',
    resourceName: 'Activity Logs',
    label: 'Activity Logs',
    icon: 'clock-fill',
  },
  {
    route: '/migrate-end-users',
    resourceName: 'Migration',
    label: 'End User Migration',
    icon: 'person-fill',
  },
  {
    route: '/notifications',
    resourceName: 'Notifications',
    label: 'Notifications',
  },
];

/**
 * Hides `requiresThreatPairModule` items only when the flag is explicitly **`false`**
 */
export function filterMenusByThreatPairModule(
  menus: typeof MENU,
  threatPairModuleEnabled: boolean | null,
): typeof MENU {
  return menus.filter(
    (m: any) =>
      !m.requiresThreatPairModule || threatPairModuleEnabled !== false,
  ) as typeof MENU;
}
